export default __webpack_public_path__ + "static/media/03_DAIF_Eco_01_01.2b4fb943.mp4";